import { render, staticRenderFns } from "./AddProductToStock.vue?vue&type=template&id=15aa1ad6&scoped=true&"
import script from "./AddProductToStock.vue?vue&type=script&lang=js&"
export * from "./AddProductToStock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15aa1ad6",
  null
  
)

export default component.exports